export class TreeBuilder {
    constructor() {
        this.EMPTY_ELEMENT_TAGS = new Set([
            'area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'menuitem', 'meta', 'param', 'source', 'track', 'wbr',
            'basefont', 'bgsound', 'command', 'frame', 'image', 'isindex', 'nextid', 'spacer'
        ]);
    }
    canBeEmptyElement(name) {
        return this.EMPTY_ELEMENT_TAGS.has(name);
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/beautiful-soup-js/build/es/main/TreeBuilder.js
// module id = null
// module chunks = 